import { SHOW_GLOBAL_LOADER } from '../actionTypes/LoaderActionTypes';

export const showGlobalLoader = (payload) => ({
    type: SHOW_GLOBAL_LOADER,
    payload,
});

export default showGlobalLoader;
